<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>参数列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
   
            <el-form
              ref="editFormRef"
              :model="editForm"
              :rules="editFormRules"
              
            >
<!-- <el-row>
  <el-col :span="6"><div class="grid-content bg-purple">123</div></el-col>
  <el-col :span="6"><div class="grid-content bg-purple-light">123</div></el-col>
</el-row>
<el-row>
  <el-col :span="6"><div class="grid-content bg-purple">123</div></el-col>
  <el-col :span="6"><div class="grid-content bg-purple-light">123</div></el-col>
</el-row> -->
              <el-form-item
                label="门店利润比率" style="width: 400px;"
                prop="fenrun_bilv" label-width="200px"  >
                <el-input  style="width: 200px;" v-model="editForm.fenrun_bilv"></el-input>
              </el-form-item>
              <el-form-item label="提现手续费"  label-width="200px" style="width: 400px;" prop="tixian_sxf">
                <el-input style="width: 200px;" v-model="editForm.tixian_sxf"></el-input>
              </el-form-item>
              <el-form-item label="奖励参数01"  label-width="200px" style="width: 400px;" prop="jiangjin01">
                <el-input style="width: 200px;" v-model="editForm.jiangjin01"></el-input>
              </el-form-item>
              <el-form-item label="奖励参数02"  label-width="200px" style="width: 400px;" prop="jiangjin02">
                <el-input style="width: 200px;" v-model="editForm.jiangjin02"></el-input>
              </el-form-item>
                <el-form-item label="wxAppId"  label-width="200px" style="width: 400px;" prop=" ">
                <el-input style="width: 200px;" v-model="editForm.wxAppId"></el-input>
              </el-form-item>
              <el-form-item label="wxAPPsecret"  label-width="200px" style="width: 400px;" prop=" ">
                <el-input style="width: 200px;" v-model="editForm.wxAPPsecret"></el-input>
              </el-form-item>

            </el-form>
            
              <el-button type="primary" @click="updateSetInfo">确 定</el-button>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 获取用户列表参数
      queryInfo: {
        C_type: 'set_info',
        query: '',
        pageNum: 1,
        pageSize: 1000
        // 最多1000个参数，此处不再分页，在添加的时候做限定，生成编号的时候进行检测
      },
      editDialogVisible: 1,
      setInfo: [],
      editForm: {},
      // 表单规则项
      addFormRules: {
        juese_name: [
          { required: true, message: '请输入参数名称', trigger: 'blur' },
          { min: 3, max: 10, message: '必须3到10位字符 ', trigger: 'blur' }
        ],
        jiangjin01: [
          { required: true, message: '请输入奖励01参数', trigger: 'blur' },
          { min: 1, max: 5, message: '必须1到5位字符 ', trigger: 'blur' }
        ],
        jiangjin02: [
          { required: true, message: '请输入奖励02参数', trigger: 'blur' },
          { min: 1, max: 5, message: '必须1到5位字符 ', trigger: 'blur' }
        ],
        juese_admin: [
          { required: true, message: '请输入参数管理员', trigger: 'blur' },
          { min: 3, max: 10, message: '必须3到10位字符', trigger: 'blur' }
        ],
        juese_mob: [
          { required: true, message: '请输入管理员手机号码', trigger: 'blur' },
          { min: 11, max: 11, message: '必须是11位 ', trigger: 'blur' }
        ]
      },
      editFormRules: {}
    };
  },
  created() {
    this.getSetInfo(0);
  },
  methods: {
    // 递交权限数据
    async getSetInfo(uid) {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_table_name: 'set_info', uid: uid, C_type: 'get_info' }
      });
      if (JSON.parse(res.data)[0].status !== 200) {
        return this.$message.error('读取失败');
      }
      this.editForm = JSON.parse(res.data)[0].data[0];
      // console.log(this.editForm)
    },

    async updateSetInfo() {
      console.log('123')
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return this.$message.error('验证错误！');
        const { data: res } = await this.$http.post('api', {
          C_type: 'SetInfo_update',
          uid: this.editForm.uid,
          fenrun_bilv: this.editForm.fenrun_bilv,
          tixian_sxf: this.editForm.tixian_sxf,
          jiangjin01: this.editForm.jiangjin01,
          jiangjin02: this.editForm.jiangjin02,
          wxAppId: this.editForm.wxAppId,
          wxAPPsecret: this.editForm.wxAPPsecret
        });

        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('更新失败');
          return;
        }
        this.$message.success('更新成功');
        this.getjueseList();
        this.editDialogVisible = false;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.card_two {
  margin-top: 30px;
  box-shadow: none !important;
}
.el_row_two {
  margin-top: 30px;
}
.wai_row_buttom {
  margin-top: 30px;
  //  border-top: 1px solid #ddd;

  background-color: #f8f8f8;
  top: 50%;
  padding: 10px;
}

.nei_row_buttom {
  margin-top: 10px;
}
.el-tag {
  margin: 7px;
}

.bdtop {
  border-top: 1px solid #ddd;
}
.bdbottom {
  border-bottom: 1px solid #ddd;
}
.vcenter {
  display: flex;
  align-items: center;
}
</style>
